import { createStyles, makeStyles, Theme } from "@material-ui/core/styles";
import { Chart } from "react-google-charts";
import {
  BOX_SHADOWS,
  DATA_TYPES,
  EMPTY_MESSAGES,
  EMPTY_MESSAGE_IMAGES,
  FONTS,
  HIST_CHART_SELECTED,
  SECONDARY_COLOR,
} from "../../constants";
import { stateType, stateTypeF } from "../../state";
import { CustomHistogram } from "../Common/CustomHistogram";
import { EmptyMessage } from "../Common/EmptyMessage";
import { makeHistData } from "../Common/makeHistData";
import { TableTabs } from "../Common/TableTabs";
import { calcCatHistData } from "./CatDropDown";
import { getCols } from "./NumericDropdown";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    container: {
      boxShadow: BOX_SHADOWS,
      backgroundColor: "white",
      width: "100%",
      height: "600px",
      display: "flex",
      flexDirection: "column",
      borderRadius: "10px",
      overflow: "hidden",
    },
    topTab: { display: "flex", flexDirection: "row" },
    chartContainer: {
      display: "flex",
      flexDirection: "column",
    },
    checkBox: {
      display: "flex",
      flexDirection: "row",
      justifyContent: "center",
      fontSize: 15,
      color: "grey",
      fontFamily: FONTS,
    },
    checkText: { whiteSpace: "nowrap", marginTop: "10px" },
  })
);

export function NumericChart({ state }: stateType) {
  let nCols = getCols(state, DATA_TYPES.number).length;
  if (nCols === 0) {
    return (
      <EmptyMessage
        image={EMPTY_MESSAGE_IMAGES.noData}
        message1={EMPTY_MESSAGES.empty1}
        message2={EMPTY_MESSAGES.empty2Num}
        button={false}
      ></EmptyMessage>
    );
  }

  let col = state.saveState.dataset.getColumn(
    state.saveState.dataUpload.numericHistSelected
  );
  if (col === undefined) {
    return <div></div>;
  }

  if (state.saveState.dataUpload.dataIngestionHistData === undefined) {
    calcNumericHistData(state);
  }

  let title = `Distribution of '${col.columnName}'`;

  return (
    <div
      style={{
        marginTop: "50px",
        marginLeft: "-50px",
        marginRight: "50px",
      }}
    >
      <CustomHistogram
        state={state}
        histData={state.saveState.dataUpload.dataIngestionHistData}
        title={title}
        isCat={false}
      ></CustomHistogram>
      ;
    </div>
  );
}

export function CategoricalChart({ state }: stateType) {
  let nCols = getCols(state, DATA_TYPES.categorical).length;
  if (nCols === 0) {
    return (
      <EmptyMessage
        image={EMPTY_MESSAGE_IMAGES.noData}
        message1={EMPTY_MESSAGES.empty1}
        message2={EMPTY_MESSAGES.empty2Cat}
        button={false}
      ></EmptyMessage>
    );
  }

  let col = state.saveState.dataset.getColumn(
    state.saveState.dataUpload.catHistSelected
  );
  if (col === undefined) {
    return <div></div>;
  }

  if (state.saveState.dataUpload.dataIngestionHistData === undefined) {
    calcCatHistData(state);
  }

  return (
    <Chart
      width={"100%"}
      height={"100%"}
      chartType="BarChart"
      loader={<div>Loading Chart</div>}
      data={[...state.saveState.dataUpload.dataIngestionHistData]}
      options={{
        series: [{ color: SECONDARY_COLOR, dataOpacity: 0.8 }],
        title: "Counts by Classes",
        chartArea: { width: "80%", height: "80%" },
        legend: { position: "none" },
        hAxis: {
          title: "Counts",
          minValue: 0,
        },
      }}
      rootProps={{ "data-testid": "1" }}
    />
  );
}

export function DistributionBox({ state }: stateType) {
  let classes = useStyles();

  function SelectedChart() {
    const selected = state.saveState.dataUpload.histTabSelected;
    if (selected === HIST_CHART_SELECTED.num) {
      return <NumericChart state={state}></NumericChart>;
    } else {
      return <CategoricalChart state={state}></CategoricalChart>;
    }
  }

  return (
    <div className={classes.container}>
      <div className={classes.topTab}>
        <TableTabs state={state}></TableTabs>
      </div>
      {SelectedChart()}
      {/* <CheckOutlier></CheckOutlier> */}
    </div>
  );
}

export function calcNumericHistData(state: stateTypeF) {
  let col = state.saveState.dataset.getColumn(
    state.saveState.dataUpload.numericHistSelected
  );
  if (col === undefined) {
    return;
  }

  let histData = makeHistData(
    state.saveState.dataset.data[col.columnName],
    col.columnType,
    new Set(),
    col.colStats.median
  );
  state.saveState.dataUpload.dataIngestionHistData = [...histData];
  state.setSaveState(state.saveState);
}
